// Module
var code = "<ldap-security-fieldset\r\n  values=\"$ctrl.reactValues\"\r\n  on-change=\"($ctrl.onChangeReactValues)\"\r\n  upload-state=\"$ctrl.getUploadState()\"\r\n  title=\"$ctrl.title\"\r\n  limited-feature-id=\"$ctrl.limitedFeatureId\"\r\n></ldap-security-fieldset>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/settings/authentication/ldap/ldap-settings-security/ldap-settings-security.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;